
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface DishTypeSelectorProps {
  dishType: string;
  onDishTypeChange: (value: string) => void;
}

export const DishTypeSelector = ({ dishType, onDishTypeChange }: DishTypeSelectorProps) => {
  // These values must match the database constraint
  const dishTypes = [
    "breakfast",
    "lunch",
    "dinner",
    "dessert",
    "baked_goods",
    "appetizer",
    "main_course",
    "side_dish"
  ];

  const formatDishType = (type: string) => {
    return type
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  return (
    <Select value={dishType} onValueChange={onDishTypeChange}>
      <SelectTrigger className="h-12 rounded-xl text-black bg-[#EDEDED] border-gray-200">
        <SelectValue placeholder="Select dish type">
          {dishType ? formatDishType(dishType) : "Select dish type"}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {dishTypes.map((type) => (
          <SelectItem key={type} value={type} className="capitalize">
            {formatDishType(type)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
